import React, { useEffect, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { StyledEngineProvider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { IOrderDetails } from 'app/models/Orders/OrderDetails';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { DateRange } from 'app/ComponentLibrary/DateRangeNew/types';

interface props {
   title: string;
  value: string;
  name: string;
  handleChange(property: string, value: any): void;
  disableEdit: boolean;
  orderDetails: IOrderDetails;
}

const useStyles = makeStyles()(theme => ({
  element: {
    marginTop: 15,
    height: 25,
  },


  dueDateField: {
    textAlign: 'left',
     font: 'normal normal normal 5px Roboto',
    color: theme.palette.framework.system.charcoal,
    letterSpacing: '0px',
    opacity: '0',
     position:'absolute',
  },
  fieldLabel: {
    textAlign: 'left',
    color: theme.palette.framework.system.charcoal,
    letterSpacing: '0px',
    opacity: '0',
  },
  input: {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    fontSize: 14,
    '& .MuiInputBase-input': {
      padding: '2px 4px 1px !important',
    },
    '& .MuiPopover-paper': {
      marginLeft: '49px',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '0.9rem',
    },
    '& .MuiIconButton-root': {
      padding: 4,
    },
  },
  borderBottom: {
    borderBottom: 'none',
    marginTop: 0,
  },
  flexContainer: {
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
  },
  flexChild: {
    width: 115,
  },
}));

export const DateEditor = (datePicker: props) => {
  const { handleChange, value, disableEdit, name, orderDetails } = datePicker;
  const [dateValue, setDateValue] = useState<string | null | { startDate: Date | string; endDate: Date | string }>(
    null,
  );
  const [dateRange, setDateRange] = useState<DateRange | null>(null);

  const handleDateChange = (name: string, date: DateRange | null) => {
    if (name === 'endDate') {
      if (orderDetails.startDate && date && date.endDate >= new Date(orderDetails.startDate)) {
        dateUpdate(name, date);
      }
      if (!date) {
        dateUpdate(name, date);
      }
    } else {
      dateUpdate(name, date);
    }
  };

  const dateUpdate = (name: string, date: DateRange | null) => {
    if (name === 'endDate') {
      setDateValue({
        startDate:date.endDate,
        endDate:date.endDate
      });
      handleChange(name, date.endDate);
      setDateRange(date);
    } else {
      setDateValue({
        startDate:date.startDate,
        endDate:date.endDate
      });
      handleChange(name, date.startDate);
      setDateRange(date);
    }
  };

  useEffect(() => {
    if (value)
      setDateValue(
        {
          startDate:new Date(value).toLocaleDateString() !== 'Invalid Date' ? new Date(value) : null,
          endDate:new Date(value).toLocaleDateString() !== 'Invalid Date' ? new Date(value) : null
        }
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const { classes, cx } = useStyles();
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div data-testid="render-DatePicker" className={classes.flexContainer}>
        <StyledEngineProvider injectFirst>
          <DateRangePicker
          
            single={true}
            quickSelect={false}
            actionBar={false}
            clickAway={true}
            applyOnClickAway={true}
            keepClickAwayVal={true}
            disableEdit={disableEdit}
            value={dateValue}
            initialDateRange={dateRange}
            showIcon={true}
            labelClass={dateRange ? classes.fieldLabel : classes.dueDateField}
            trailingIconShow={true}
            minDate={orderDetails.startDate}
            defaultFirstMonth={
              name === 'endDate'
                ? value && new Date(value).toLocaleDateString() !== 'Invalid Date'
                  ? new Date(value)
                  : orderDetails.startDate
                    ? new Date(orderDetails.startDate)
                    : undefined
                : undefined
            }
            onChange={v => handleDateChange(name, v)}
            className={cx(classes.element, classes.input, classes.borderBottom, classes.flexChild)}
          />
        </StyledEngineProvider>
      </div>
    </LocalizationProvider>
  );
};
